import { Formik } from "formik";
import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import {
  Dialog as MUIDialog,
  DialogContent,
  DialogTitle,
  Typography,
  IconButton,
} from "@mui/material";

import CreateWorkflowForm from "./CreateWorkflowForm";
import { CancelOutlined } from "@mui/icons-material";
import { useAxios } from "../../../hooks";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { alert } from "../../../redux/slices/alertSlice";
import pages from "../../../constants/pages";

const useStyles = makeStyles(() => ({
  paper: { minWidth: "600px" },
}));

export default function WorkflowDialog({ dialogState, setDialogState }) {
  const axios = useAxios();
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { activeBot } = useSelector((state) => state.memberDetails);

  const [formData] = useState({
    workflowName: "",
    workflowDescription: "",
  });

  const handleClose = (e, reason) => {
    if (reason && reason === "backdropClick") return;

    setDialogState(false);
  };

  return (
    <React.Fragment>
      <MUIDialog
        classes={{ paper: classes.paper }}
        open={dialogState}
        onClose={handleClose}
      >
        <DialogTitle style={{ borderBottom: "1px solid #cbcbcb" }}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="h4">Create Workflow</Typography>

            <IconButton onClick={handleClose} style={{ padding: 0 }}>
              <CancelOutlined />
            </IconButton>
          </div>
        </DialogTitle>

        <DialogContent>
          <Formik
            enableReinitialize
            initialValues={formData}
            validateOnMount
            onSubmit={(formData, { setSubmitting }) => {
              axios({
                url: "/workflow/" + activeBot.ID,
                method: "POST",
                disableRedirect: true,
                data: {
                  is_active: true,
                  description: formData.workflowDescription,
                  workflow_name: formData.workflowName,
                },
              }).then((response) => {
                if (response.status) {
                  dispatch(
                    alert({
                      type: "success",
                      message: response.message.displayMessage,
                    })
                  );
                  navigate(
                    pages.workflowDetailsPage.route + response.data?.workflow_id
                  );
                }
              });
              setSubmitting(false);
            }}
          >
            {(formikProps) => <CreateWorkflowForm formikProps={formikProps} />}
          </Formik>
        </DialogContent>
      </MUIDialog>
    </React.Fragment>
  );
}

/* padding: "0px 24px 16px"  */
